@import "/src/styles/mixins.sass"

.container
    border-radius: 0.5rem
    background-color: var(--color-black-primary)
    display: flex
    align-items: center
    flex-wrap: wrap
    padding: 0.5rem

.text
    padding: 0.5rem
    flex: 7 0
    @include text--regular
    color: var(--color-white-primary)

.buttons
    flex: 1 0
    display: flex
    justify-content: flex-end
    gap: 1rem

.action span
    padding: 0.5rem
    @include text
    color: var(--color-orange-attention)

.close span
    padding: 0.5rem
    color: var(--color-white-primary)

.action, .close
    &:hover
        background-color: var(--color-grey-dark)
